// extracted by mini-css-extract-plugin
module.exports = {"link":"SimpleTeaser_link__JfKaX","message":"SimpleTeaser_message__yhpVV","wrapper":"SimpleTeaser_wrapper__MKMf0"};